/* Carrier Codes Store */

import {fetchCarrierCodes} from '@/api'

const state = {
    codes: []
}

const actions = {
    fetchCarrierCodes (context, params) {
        return fetchCarrierCodes(params).then(r => {
            context.commit('setCarrierCodes', r.data)
        })
    }
}

const mutations = {
    setCarrierCodes (state, payload) {
        state.codes = payload
    }
}

const getters = {
    getCarrierCodes (state) {
        return state.codes
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
